const PersonalizeContent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 16.6663H4.33268C3.39926 16.6663 2.93255 16.6663 2.57603 16.4847C2.26243 16.3249 2.00746 16.0699 1.84767 15.7563C1.66602 15.3998 1.66602 14.9331 1.66602 13.9997V5.99967C1.66602 5.06625 1.66602 4.59954 1.84767 4.24302C2.00746 3.92942 2.26243 3.67445 2.57603 3.51466C2.93255 3.33301 3.39926 3.33301 4.33268 3.33301H4.66602C6.53286 3.33301 7.46628 3.33301 8.17932 3.69632C8.80652 4.0159 9.31646 4.52583 9.63604 5.15304C9.99935 5.86608 9.99935 6.7995 9.99935 8.66634M9.99935 16.6663V8.66634M9.99935 16.6663H15.666C16.5994 16.6663 17.0661 16.6663 17.4227 16.4847C17.7363 16.3249 17.9912 16.0699 18.151 15.7563C18.3327 15.3998 18.3327 14.9331 18.3327 13.9997V5.99967C18.3327 5.06625 18.3327 4.59954 18.151 4.24302C17.9912 3.92942 17.7363 3.67445 17.4227 3.51466C17.0661 3.33301 16.5994 3.33301 15.666 3.33301H15.3327C13.4658 3.33301 12.5324 3.33301 11.8194 3.69632C11.1922 4.0159 10.6822 4.52583 10.3627 5.15304C9.99935 5.86608 9.99935 6.7995 9.99935 8.66634"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PersonalizeContent;
